export default function StepIndicator({ categoryStep, pageStep }) {
    /// ✅ pageStep : 1 = 분류 , 2 = 기타 , 3 = 기타~완료 , 4 = 완료
    return (
        <div style={{ display: "flex", alignItems: "center", padding: "24px 16px" }}>
            {/* Step 1 */}
            <div
                style={{
                    display: "flex",
                    width: "32px",
                    height: "32px",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "9999px",
                    backgroundColor: "#2E4A24",
                }}
            >
                <div className="f14_FFFFFF_W400">1</div>
            </div>
            <div style={{ width: "8px" }} />
            <div className="f14_1F2937_W500">분류</div>

            {/* Line 1 */}
            <div style={{ width: "4px" }} />
            <div
                style={{
                    flex: "1",
                    height: "2px",
                    backgroundColor: "#D1D5DB",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        height: "100%",
                        backgroundColor: "#2E4A24",
                        width: categoryStep === 1 && "0%" || categoryStep === 2 && "33%" || categoryStep === 3 && "66%" || categoryStep === 4 && "100%",
                        transition: "all 0.3s ease",
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                />
            </div>

            {/* Step 2 */}
            <div style={{ width: "4px" }} />
            <div
                style={{
                    display: "flex",
                    width: "32px",
                    height: "32px",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "9999px",
                    backgroundColor: pageStep >= 2 ? "#2E4A24" : "#E5E7EB",
                }}
            >
                <div className={pageStep >= 2 ? "f14_FFFFFF_W400" : "f14_6B7280_W400"}>2</div>
            </div>
            <div style={{ width: "8px" }} />
            <div className={pageStep >= 2 ? "f14_1F2937_W500" : "f14_6B7280_W400"}>기타</div>

            {/* Line 2 */}
            <div style={{ width: "4px" }} />
            <div
                style={{
                    flex: "1",
                    height: "2px",
                    backgroundColor: "#D1D5DB",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        height: "100%",
                        backgroundColor: "#2E4A24",
                        width: pageStep >= 3 ? "100%" : "0%",
                        transition: "all 0.3s ease",
                        position: "absolute",
                        top: 0,
                        left: 0,
                    }}
                />
            </div>

            {/* Step 3 */}
            <div style={{ width: "4px" }} />
            <div
                style={{
                    display: "flex",
                    width: "32px",
                    height: "32px",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "9999px",
                    backgroundColor: pageStep >= 4 ? "#2E4A24" : "#E5E7EB",
                }}
            >
                <div className={pageStep >= 4 ? "f14_FFFFFF_W400" : "f14_6B7280_W400"}>3</div>
            </div>
            <div style={{ width: "8px" }} />
            <div className={pageStep >= 4 ? "f14_1F2937_W500" : "f14_6B7280_W400"}>완료</div>
        </div>
    );
};